import { Component, type ReactNode } from 'react'
import { RefreshCw, WifiOff } from 'lucide-react'

export default class PageBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  render() {
    if (!this.state.failed) return this.props.children
    return <div className="page page-recovery" role="alert">
      <WifiOff size={32} aria-hidden="true" />
      <h1>Не удалось открыть раздел</h1>
      <p>Проверьте подключение и обновите приложение. Это также поможет, если во время работы вышла новая версия.</p>
      <button className="button primary" onClick={() => window.location.reload()}><RefreshCw size={18} />Обновить приложение</button>
    </div>
  }
}
